import React, { useState ,useContext} from 'react'
import {AppFormItemProps,AppFormContext} from '../AppForm/index'
import {AppText,AppTextProps} from '../AppText'


export const AppFormItemText = (props:AppFormItemProps) =>{
    
    const {onChange,formData} = useContext(AppFormContext);
    const textProps = {...props} as AppTextProps;


    const handleChange = (value:string) =>{
        let itemProps = {...props,value} as AppFormItemProps ;
        onChange && onChange(itemProps);
    }


    return <AppText {...textProps} value={formData[props.keyName]} onChange={handleChange}/>
}


// WEBPACK FOOTER //
// ./src/qcc/AppFormItem/AppFormItemText.tsx